import { Category } from '@df/catalog/category/category';
import { IProductDataV2, Product } from '@df/catalog/product/product';
import { SearchResult } from '@df/search/search-result';
import { ProductDecorator } from '../catalog/model/product/product.decorator';

declare module '@df/search/search.interfaces' {
    export namespace Search {
        export interface IResult {
            term?: string;
        }
    }
}

export class SearchResultDecorator extends SearchResult {
    protected override applyProductFilter(models: Product[]): Product[] {
        models = (models as ProductDecorator<IProductDataV2>[]).filter(
            product => product.data?.display_search_if_oos || (!product.isOutOfStock && !product.stock?.data?.isOutTemp)
        );
        return models;
    }

    /**
     * Categories getter
     */
    override get categories(): Category[] | undefined {
        return this.getModels<Category>('category')?.filter(model => !model.data?.['is_exclude_cat']);
    }
}
